// SEARCH ポップアップ（総合版→都道府県選択→エリアTOP初回到達時のみ、右側に自動表示）
// Figma PC 5077:23199 / SP 5053:22287
const PENDING_KEY = 'ymh_search_popup_pending';

// 選んだ種別を「〜から探す」のリンクへ反映する
//
// 種別の選択だけでは遷移させず、さがし方を選んだ時点で
// ?type=... 付きのURLへ飛ばす。クリックを横取りせず href を書き換えるのは、
// target="_blank" や Ctrl+クリック・新しいタブで開く、といった
// ブラウザ標準の挙動をそのまま残すため。
//
// ※href のパスには触れない。本番の /bunjo 接頭辞はサーバが描画した href に
//   既に入っているので、クエリだけ足せば環境差を考えなくてよい
//
// 【2026-08-21 チェックボックス → ラジオ。設計メモ D25】
// 種別は常に1つだけ選ばれているので、積むクエリも常に1つ（type=<種別>）。
// 「全部チェック＝全種別」を type=all へ読み替えていた分岐は不要になった。
// 同日に「すべて」タブ（value=all）も撤去したので、**ここから飛ぶ type は
// 必ず実在の4種別のどれか**になる（type=all を積むことはもう無い）。
// name が type[] ではなく search_popup_type なのは、全ページに出るこのポップアップと
// 物件一覧の種別タブが同じラジオグループに融合するのを避けるため
// （どちらもフォーム外なので name が同じだと1グループになる。_search-popup.blade.php 参照）
const syncWayLinks = (popup) => {
    const inputs = Array.from(popup.querySelectorAll('input[name="search_popup_type"]'));
    if (!inputs.length) return;

    // 地図は search.map が種別を見ない（EstateController::map）ので、
    // 効かない絞り込みがURLに載らないよう対象外にする
    const links = Array.from(popup.querySelectorAll('.c-search-ways-nav__item'))
        .filter((link) => !link.hasAttribute('target'));
    if (!links.length) return;

    // 書き換えを重ねるとクエリが増え続けるため、素のURLを控えておく
    const bases = new Map(links.map((link) => [link, link.getAttribute('href')]));

    const apply = () => {
        const selected = inputs.find((input) => input.checked)?.value;

        links.forEach((link) => {
            const url = new URL(bases.get(link), window.location.origin);
            url.searchParams.delete('type');
            url.searchParams.delete('type[]');
            // 未選択（サーバが1つも checked を出さなかったとき）は素のURL＝サーバ既定に任せる。
            // ラジオなので実際には起こらないが、type= を空で積むよりは既定に落ちる方が安全
            if (selected) url.searchParams.set('type', selected);
            link.setAttribute('href', url.pathname + url.search + url.hash);
        });
    };

    inputs.forEach((input) => input.addEventListener('change', apply));
    apply();
};

const main = () => {
    const popup = document.querySelector('.js-home-search-popup');
    if (!popup) return;

    const open = () => {
        popup.setAttribute('data-active', 'true');
        popup.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
    };
    const close = () => {
        popup.setAttribute('data-active', 'false');
        popup.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
    };

    syncWayLinks(popup);

    popup.querySelectorAll('[data-close]').forEach((el) => el.addEventListener('click', close));
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && popup.getAttribute('data-active') === 'true') close();
    });

    // 総合版のエリア選択ポップアップから遷移してきた直後のみ1回表示（sessionStorageは遷移後に消費）
    let pending = false;
    try { pending = sessionStorage.getItem(PENDING_KEY) === '1'; } catch (e) { pending = false; }
    if (pending) {
        try { sessionStorage.removeItem(PENDING_KEY); } catch (e) { /* noop */ }
        window.requestAnimationFrame(open);
    }
};

export default main;
